<template>
    <f7-page id="account-my-details" name="account-my-details" @page:afterin="afterin">
        <f7-navbar class="view-mobile no-border">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <div class="block">
            <div class="fw-bold fs-24 mb-lg">{{ $t('ua-my-details') }}</div>

            <f7-card
                :title  ="alertCard.title"
                class   ="alert"
                :class  ="alertCard.class"
                :id     ="alertCard.id"
                v-show  ="alertCard.show"
            >
                <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
            </f7-card>

            <f7-card
                :title  ="$t('ua-need-update-personal-detail-title')"
                :content="$t('ua-need-update-personal-detail-message')"
                class   ="alert alert-success no-icon"
                :class  ="alertCard.show?'mt-3':''"
                v-show ="isNeedToUpdateDetails"
            >
                <i class="icon f7-icons card-close" @click="isNeedToUpdateDetails=false">xmark</i>
            </f7-card>

            <f7-list form class="form-group">
                <f7-list-input
                    input-id      ="fullName"
                    name          ="fullName"
                    type          ="text"
                    class         =""
                    placeholder   =""
                    :value        ="customerName.trim().toLowerCase() == 'customer' ? '' : customerName"
                    :label        ="$t('regis-full-name')"
                    autocomplete  ="off"
                    outline
                    floating-label
                    required
                    :disabled     = "true"
                ></f7-list-input>

                <f7-list-input
                    input-id      ="nationality"
                    name          ="nationality"
                    class         ="clickable-row use-chevron"
                    type          ="text"
                    :label        ="$t('regis-nationality')"
                    :placeholder  ="$t('regis-nationality')"
                    :value        ="nationalityId == 0 ? '': nationality"
                    outline
                    floating-label
                    :disabled     = "true"
                >
                </f7-list-input>

                <f7-list-input
                    input-id      ="dob1"
                    name          ="dob1"
                    type          ="text"
                    :label        ="$t('regis-dob')"
                    :placeholder  ="$t('regis-dob')"
                    :value        ="dob == '1950-01-01' ? '' : dob.split('-').reverse().join('-')"
                    outline
                    floating-label
                    :disabled     = "true"
                >
                </f7-list-input>

                <f7-list-input
                    input-id      ="gender"
                    name          ="gender"
                    class         ="clickable-row use-chevron"
                    type          ="text"
                    :label        ="$t('regis-gender')"
                    :placeholder  ="$t('regis-gender')"
                    :value        ="gender"
                    outline
                    floating-label
                    :disabled     = "true"
                >
                </f7-list-input>

                <f7-list class="form-group">
                    <f7-list-input
                        input-id     ="userMobileNo"
                        name         ="userMobileNo"
                        type         ="tel"
                        class        ="mobile-input"
                        :label       ="$t('regis-mob-num')"
                        placeholder  =""
                        :value       ="mobile"
                        outline
                        floating-label
                        :readonly     = "true"
                    >
                        <div class="edit-account-details" @click="updateDetails('mobileNo')" slot="content-end" style="">
                          <a class="fs-14 fw-medium">EDIT</a>
                        </div>

                        <f7-link popover-open=".popover-mobile-no" slot="content-start" class="flag-with-chevron" @click="$event.preventDefault()" >
                          <img :src="getFlagImg(mobileCountryId)" class="" />
                          <span class="">{{ mobileCountryCode }}</span>
                        </f7-link>
                    </f7-list-input>

                </f7-list>

                <f7-list-input
                    input-id      ="userEmail"
                    name          ="userEmail"
                    type          ="email"
                    :label        ="$t('regis-email')"
                    :placeholder  ="$t('regis-email')"
                    :value        ="email"
                    @input        ="email = $event.target.value;"
                    autocomplete  ="off"
                    outline
                    floating-label
                    :readonly     = "true"
                >
                    <div class="edit-account-details" @click="updateDetails('email')" slot="content-end" style="">
                      <a class="fs-14 fw-medium">EDIT</a>
                    </div>
                </f7-list-input>

                <f7-list-input
                    input-id      ="occupation1"
                    name          ="occupation1"
                    type          ="text"
                    class         =""
                    placeholder   =""
                    :value        ="occupation"
                    @change       ="occupation = $event.target.value;"
                    :label        ="$t('regis-occupation')"
                    autocomplete  ="off"
                    outline
                    floating-label
                    :disabled     = "true"
                >
                </f7-list-input>

            </f7-list>

            <div class="card">
                <div class="card-content-padding">
                    <div class="wandr-subtitle-2 mb-md">{{ $t('ua-update-account-title') }}</div>
                    <f7-list>
                        <f7-list-item @click="navigateToUpdateDocs(1)">
                            <div class="display-flex">
                                <img :src="require('@/assets/img/ekyc/ic_doc_upload.svg')"/>
                                <p class="ms-2 ps-1">{{ $t('ua-option-docs') }}</p>
                            </div>
                            <i class="f7-icons">chevron_right</i>
                        </f7-list-item>
                        <f7-list-item @click="navigateToUpdateDocs(2)">
                            <div class="display-flex">
                                <img :src="require('@/assets/img/ekyc/ic_doc_upload.svg')"/>
                                <p class="ms-2 ps-1">{{ $t('ua-option-myinfo') }}</p>
                            </div>
                            <i class="f7-icons">chevron_right</i>
                        </f7-list-item>
                    </f7-list>
                </div>
            </div>

        </div>
    </f7-page>
</template>

<script>
    import ApiService from "../../services/api-main";
    import { mapGetters, mapActions } from "vuex";
    import { dateHelper } from '@/plugins/helper';
    export default {
        props: {
            isFromUpdateMobile: Boolean,
            isFromUpdateEmail: Boolean
        },
        mounted (){
            // Required for everypage. Toggle desktop-view footer.
            this.toggleFooterVisibility(false)
            this.$f7.$('.page-content').on('scroll', (e) => {
                this.toggleFooterVisibility(e.target)
            })
            this.getCountryList();
            this.getCustomerDetail();
            this.validateUpdateDetails();
            //console.log("IS EMAIL VERIFIED : "+this.emailVerified)

            //RESET STORE (UPDATE DETAILS PROPS)
            this.setTempUpdateAccountType(0);
            this.setTempUpdateAccountData({});
            this.setUpdateTempCurrMobileCountryCode({id: 189, idd: "+65"});
            this.setUpdateTempNewMobileCountryCode({id: 189, idd: "+65"});
            this.setUpdateTempCurrMobileNo("");
            this.setUpdateTempNewMobileNo("");
            this.setUpdateTempNewEmail("");
            this.setUpdateTempConfirmNewEmail("");
        },
        data() {
            return {
                isFormInputValid    : false,
                isNeedToUpdateDetails: false,
                countryList         : [],
                occupationList      : [],
                alertCard: { show: false, title: "", class:"alert-success", id: "successCard" },
                checkWindow         : undefined,
                checkTimer          : null,
            }
        },
        destroyed() {
            if (window.updateAccountMyInfoCallback) window.updateAccountMyInfoCallback = null;
        },
        methods: {
            ...mapActions('auth', ['login']),
            ...mapActions('customer', ['setCustomerName', 'setDoB', 'setCustomerNationality', 'setCustomerGender', 'setCustomerEmail', 'setEmailVerified', 'setMobileIDD', 'setMobile','setOldEmail','setIsOldEmailUpdated', 'setTempUpdateAccountType', 'setTempUpdateAccountData', 'setUpdateTempCurrMobileCountryCode', 'setUpdateTempCurrMobileNo', 'setUpdateTempNewMobileCountryCode', 'setUpdateTempNewMobileNo', 'setUpdateTempNewEmail', 'setUpdateTempConfirmNewEmail']),
            ...mapActions('staticData', ['getCountryList']),
            ...mapActions('myinfo', [
                'setAddress',
                'setDob',
                'setEmail',
                'setEmployerName',
                'setEmploymentSector',
                'setFullname',
                'setGender',
                'setIdentificationNo',
                'setNationality',
                'setOccupation',
                'setPassExpiryDate',
                'setPassStatus',
                'setPassType',
                'setResidentialStatus',
                'setEnabledField',
                'setMyInfoState',
                'setMyInfoCode',
                'setOccupationList',
                'setNationalityList',
                'setRouterTo',
            ]),
            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },
            async getCustomerDetail() {
                try {
                    this.showPreloader();
                    //console.log("this.isOldEmailUpdated : "+ this.isOldEmailUpdated)
                    const isEmailVerified = this.emailVerified;
                    const result = await this.$api.customer.getCustomerDetails();
                    this.hidePreloader();
                    if(result && result != undefined) {
                        this.setCustomerName(result.customerName);
                        this.setDoB(result.dob);
                        this.setCustomerNationality({id: result.nationalityId, name: result.nationality});
                        this.setCustomerGender(result.gender);
                        this.setCustomerEmail(result.email);
                        this.setEmailVerified(result.emailverified);
                        this.setMobile(result.mobile);
                        this.setMobileIDD({id: result.mobileCountryId, name: result.mobileCountryCode});
                        if(!this.isOldEmailUpdated){
                            this.setOldEmail(result.email)
                            this.setIsOldEmailUpdated(true);
                        }
                    }

                    this.validateUpdateDetails();
                    this.alertCard.show = (this.isFromUpdateMobile || this.isFromUpdateEmail || (!isEmailVerified && this.emailVerified));
                    if(this.isFromUpdateMobile) {
                        this.alertCard.title = this.$t('ua-phone-number-changed');
                    } else if((this.isFromUpdateEmail && this.emailVerified) || (!isEmailVerified && this.emailVerified)) {
                        this.alertCard.title = this.$t('ua-email-changed');
                    } else if(this.isFromUpdateEmail) {

                        //console.log("OLD : "+this.oldEmail+" ## NEW : "+result.email)
                        if(this.oldEmail.toLowerCase().trim() == result.email.toLowerCase().trim()){
                            this.alertCard.title = this.$t('ua-personal-details-updated');
                            this.alertCard.class = 'alert-success mb-sm';
                            this.alertCard.id = 'successCard';
                        }else{
                            this.alertCard.title = this.$t('ua-need-verify-email');
                            this.alertCard.class = 'alert-danger';
                            this.alertCard.id = 'errorCard';
                        }
                    }

                } catch(e){
                    this.hidePreloader();
                    if(e.message.toLowerCase().includes("undefined")) {
                        this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    } else {
                        this.$f7.dialog.alert(e.message);
                    }
                }
            },
            async getCountryList() {
                const self = this;
                this.showPreloader();
                this.$api.staticData.getCountryList().then(function(result) {
                    self.countryList = result.filter(country => country.isHidden == false);
                    self.hidePreloader();
                });
            },
            validateUpdateDetails(){
                this.isNeedToUpdateDetails = this.customerName == '' || this.customerName.trim().toLowerCase() == 'customer' || this.dob == '1950-01-01' || this.nationalityId == 0 || this.gender == '';
            },
            updateDetails(fieldName){
                if(ApiService.getFormData("passReq") && ApiService.getFormData("passReq") == 'false') {
                    this.appleSignIn(4, false);

                    this.$root.$once('handleApleValidationStatus', async (token) => {
                        this.hidePreloader();
                        const response = this.parseJwt(token);
                        if(response && response != '') {
                            if(response.email == this.$store.state.customer.email) {
                                if(fieldName == 'email') {
                                    this.setTempUpdateAccountType(1);
                                    this.setTempUpdateAccountData({email: response.email, token: token, passReq: false})
                                    this.$f7router.navigate("/account/edit-details", { transition: 'f7-push', props: { type: 1, data: {email: response.email, token: token, passReq: false} } });
                                } else if(fieldName == 'mobileNo') {
                                    this.setTempUpdateAccountType(2);
                                    this.setTempUpdateAccountData({token: token});
                                    this.$f7router.navigate("/account/edit-details", { transition: 'f7-push', props: { type: 2, data: {token: token} } });
                                }
                            } else {
                                this.$f7.dialog.alert(this.$t('regis-email-invalid'));
                            }
                        }
                    });
                } else if(fieldName == 'email') {
                    this.setTempUpdateAccountType(1);
                    this.setTempUpdateAccountData({email: this.$store.state.customer.email, token: '', passReq: true});
                    this.$f7router.navigate("/account/edit-details", { transition: 'f7-push', props: { type: 1, data: {email: this.$store.state.customer.email, token: '', passReq: true} } });
                } else if(fieldName == 'mobileNo') {
                    this.setTempUpdateAccountType(2);
                    this.setTempUpdateAccountData({});
                    this.$f7router.navigate("/account/edit-details", { transition: 'f7-push', props: { type: 2 } });
                }
            },
            async navigateToUpdateDocs(type) {
                if(type == 1) {
                    this.$f7router.navigate("/verify", { transition: 'f7-push' });
                } else {
                    const self = this
                    //console.log("OLD EMAIL = "+self.oldEmail)
                    self.showPreloader();
                    const isUsingInAppBrowser = self.isMyInfoUseInAppBrowser();
                    const response = await self.$api.customer.getMyInfoUrl(isUsingInAppBrowser);
                    if(response && response != undefined && response.value != '') {
                        self.setRouterTo('account');
                        window.updateAccountMyInfoCallback = self.updateAccountMyInfoCallback;
                        if(!isUsingInAppBrowser) {
                            self.checkTimer = setInterval(function(){ if(self.checkWindow.closed) {self.updateAccountMyInfoCallback(false, '', '');} }, 1000);
                        }

                        if(isUsingInAppBrowser) {
                            this.openMyInfoInMobile(response.value);
                            this.$root.$once("proceedMyInfoMobileCallback", (isUserCancel, state, code) => {
                                this.updateAccountMyInfoCallback((state != '' && code != ''), state, code);
                            });
                        } else if(self.checkWindow !== undefined) {
                            self.checkWindow.location.replace(response.value);
                        } else {
                            self.checkWindow = window.open(response.value, '_blank', "fullscreen=1");
                        }
                    } else {
                        self.hidePreloader();
                    }
                }
            },
            async updateAccountMyInfoCallback(isSuccess, state, code) {
                window.updateAccountMyInfoCallback = null;
                this.hidePreloader();
                this.setMyInfoState(state);
                this.setMyInfoCode(code);
                this.closePopupOnMobile();
                if(this.checkWindow !== undefined) {
                    clearInterval(this.checkTimer);
                    this.checkWindow.close();
                    this.checkWindow = undefined;
                }

                if(isSuccess) {
                    this.showPreloader();
                    try {
                        const result = await this.$api.registration.getRegisterMyInfoDetail(this.isMyInfoUseInAppBrowser(), code, state);
                        if(result.status == "4854"){
                            const myInfoData = result.result;

                            this.setAddress(myInfoData.address.streetAddress);

                            // FORMAT DOB
                            const dobVal = new Date(myInfoData.dateOfBirth);
                            var formattedToday = '';
                            if(dobVal instanceof Date && !isNaN(dobVal)) {
                                const yyyy = dobVal.getFullYear();
                                let mm = dobVal.getMonth() + 1; // Months start at 0!
                                let dd = dobVal.getDate();

                                if (dd < 10) dd = '0' + dd;
                                if (mm < 10) mm = '0' + mm;

                                formattedToday = dd + '-' + mm + '-' + yyyy;
                            }
                            this.setDob(formattedToday);
                            // END OF FORMAT DOB

                            this.setEmail(myInfoData.email);
                            this.setEmployerName(myInfoData.employer);
                            this.setEmploymentSector(myInfoData.industry);
                            this.setFullname(myInfoData.name);
                            this.setGender(myInfoData.gender);
                            this.setIdentificationNo(myInfoData.identificationNo);
                            this.setNationality({id: myInfoData.nationalityId, name: myInfoData.nationality});
                            this.setOccupation(myInfoData.occupation);
                            this.setPassExpiryDate(dateHelper.formatDateOnly(myInfoData.idExpiryDate));
                            this.setPassStatus(myInfoData.idStatus || "");
                            this.setPassType(myInfoData.identificationType);
                            this.setResidentialStatus({id: myInfoData.residentialStatusId, name: myInfoData.residentialStatus || ""});
                            this.setEnabledField(myInfoData.enabledField);

                            this.$f7router.navigate("/register-myinfo-verify-detail", { props: { isUpdateAccount: true } });
                            this.hidePreloader();
                        }else if(result.status == "0104"){
                            this.alertCard.show = true;
                            this.alertCard.title = "Your ID already exist in our system.";
                            this.alertCard.class = 'alert-danger';
                            this.alertCard.id = 'errorCard';
                            this.hidePreloader();
                        } else {
                            console.log("get details: ERROR -> "+result.status);
                            this.hidePreloader();
                        }
                    } catch(e){
                        this.hidePreloader();
                        if(e.message.toLowerCase().includes("undefined")) {
                            this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                        } else {
                            this.$f7.dialog.alert(e.message);
                        }
                    }
                }
            },
            backButton() {
                this.$f7router.navigate("/account", { transition: 'f7-push' });
            }
        },
        computed: {
            ...mapGetters('auth', [
                'authenticating',
                'authenticationError',
                'authenticationErrorCode',
                'authenticationSuccess'
            ]),

            ...mapGetters('customer', [
                'customerName',
                'email',
                'emailVerified',
                'mobile',
                'mobileCountryId',
                'mobileCountryCode',
                'nationality',
                'nationalityId',
                'dob',
                'gender',
                'sourceRemittance',
                'occupation',
                'oldEmail',
                'isOldEmailUpdated'
            ])
        }
    }
</script>